import React from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";

import Link from "@material-ui/core/Link";

import Box from "@material-ui/core/Box";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import Container from "@material-ui/core/Container";

import axios from "axios";
import Alert from "@material-ui/lab/Alert";

import { Collapse } from "@material-ui/core";
import { observer } from "mobx-react";
import Store from "../../stores/userStore";
import { Helmet } from "react-helmet";

import { LOGIN } from "../../constant";
import attendance1 from '../../stores/attendanceStore';
import  moment from 'moment';
import 'moment/locale/ko';
import { toJS } from "mobx";
import user from "../../stores/userStore";
import swal from "sweetalert2";

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {"Copyright © "}
      <Link color="inherit" href="http://www.infotech21.co.kr/">
        인포테크
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const styles = (theme) => ({
  paper: {
    marginTop: 120,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: 0,
    backgroundColor: "red",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: 0,
  },
  submit: {
    margin: 0,
  },
  error: {
    marginTop: 10,
  },
});

const View = observer(
  class SignIn extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        userid: "",
        userpw: "",
        IsError: false,
        errorMessage: "",
        isLogining: false,
      };
      this.handleChange = this.handleChange.bind(this);
      this.handleClick = this.handleClick.bind(this);
    }

    componentDidMount = async () => {
      await user.getUserList();
      await attendance1.getList();
    }

    handleChange = (e) => {
      this.setState({
        [e.target.name]: e.target.value,
      });
    };

    handleClick = async () => {
      try {
        var userid = this.state.userid;
        var userpw = this.state.userpw;
        this.setState({ isLogining: true });
        const response = await axios.post(LOGIN, {
          userid: userid,
          userpw: userpw,
        });

        if(response != null){
          var nowDate = moment().format("YYYY/MM/DD");
          const userNames = toJS(user).userList;
          const attList = toJS(attendance1).list;
          const username = userNames.find((e)=>{
            if(e.userid === userid){
                return e;
            }
          })
          const lName = username.username;
          const autoChk = username.autoChk;
          const llist = attList.find((e)=>{
            if(moment(e.inTime).format("YYYY/MM/DD") === nowDate || (autoChk == 'N' || autoChk == null || autoChk == '')){
              if(e.lName === lName){
                if(e.userid === userid){
                  return moment(e.inTime).format();
                }
              }
            }else{
              return null;
            }
          });
          if(llist == null){
            try{
              await attendance1.addAttendance(userid, lName, nowDate);
              swal.fire({
                text : '자동 출근 처리되었습니다.',
                icon : 'success',
                confirmButtonText: "확인",
                allowEnterKey : true,
              })
            }catch{
            }
          }
        }


        Store.setUser(response.data);
        Store.setCharge(false);
        this.setState({ isLogining: false });
      } catch (error) {
        var message =
          "statuscode : " +
          error.response.status +
          " statusText:" +
          error.response.statusText +
          " message:" +
          error.response.data.message;
        Store.setError(error);
        this.setState({
          IsError: true,
          errorMessage: message,
          isLogining: false,
        });
      }
    };

    render() {
      const { classes } = this.props;

      return (
        <Container component="main" maxWidth="xs">
          <Helmet>
            <meta charSet="utf-8" />
            <meta name="title" content="인포테크 유지보수관리" />
            <meta
              name="description"
              content="인포테크 유지보수관리 웹사이트입니다."
            />
            <title>인포테크 통합 유지보수관리</title>

            <meta property="og:url" content="" />
            <meta
              property="og:description"
              content="인포테크 유지보수관리 웹사이트입니다."
            />
            <meta property="og:title" content="인포테크 유지보수관리" />
          </Helmet>
          <CssBaseline />
          <div className={classes.paper}>
            <Avatar className={classes.avatar}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <form className={classes.form} noValidate>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="userid"
                label="ID"
                name="userid"
                autoComplete="userid"
                autoFocus
                value={this.state.userid}
                onChange={this.handleChange}
              />
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                name="userpw"
                label="Password"
                type="password"
                id="userpw"
                autoComplete="current-password"
                value={this.state.userpw}
                onChange={this.handleChange}
                onKeyPress={(e) => {
                  if (e.key === "Enter") {
                    this.handleClick(e);
                  }
                }}
              />
              {/* <FormControlLabel
                control={<Checkbox value="remember" color="primary" />}
                label="Remember me"
              /> */}
              <Button
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                className={classes.submit}
                onClick={this.handleClick}
                disabled={this.state.isLogining}
              >
                Sign In
              </Button>
              {/* <Grid container>
                <Grid item xs>
                  <Link href="#" variant="body2">
                    Forgot password?
                  </Link>
                </Grid>
                <Grid item>
                  <Link href="#" variant="body2">
                    {"Don't have an account? Sign Up"}
                  </Link>
                </Grid>
              </Grid> */}
            </form>
            <Collapse in={this.state.IsError}>
              <Alert severity="error" className={classes.error}>
                {this.state.errorMessage}
              </Alert>
            </Collapse>
          </div>
          <Box mt={8}>
            <Copyright />
          </Box>
        </Container>
      );
    }
  }
);

export default withStyles(styles)(View);
